import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-74dc1a97"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container flex grow align-center justify-center g24",
  style: {"background":"url('/images/bg.jpg')","background-size":"cover"}
}
const _hoisted_2 = { class: "panel flex align-center justify-center g24" }
const _hoisted_3 = {
  class: "flex col g24 align-center justify-center",
  style: {"width":"350px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo flex col align-center",
  style: {"margin-bottom":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "120",
    src: "/ico/logo.svg"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    width: "140",
    src: "/ico/label.svg"
  })
], -1))
const _hoisted_5 = {
  class: "text-muted center bold f16 align-center justify-center",
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeButton = _resolveComponent("SeButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Lang.getI18N("password-change-required")), 1),
        _withDirectives(_createElementVNode("span", { class: "text-red bold" }, _toDisplayString(_ctx.error), 513), [
          [_vShow, _ctx.error != '']
        ]),
        _createVNode(_component_SeInput, {
          type: "password",
          class: "w100",
          placeholderBase: _ctx.Lang.getI18N('new-password'),
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
        }, null, 8, ["placeholderBase", "modelValue"]),
        _createVNode(_component_SeInput, {
          modelValue: _ctx.passwordConf,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordConf) = $event)),
          type: "password",
          class: "w100",
          placeholderBase: _ctx.Lang.getI18N('password-conf')
        }, null, 8, ["modelValue", "placeholderBase"]),
        _createVNode(_component_SeButton, {
          ref: "applyBtn",
          onPress: _ctx.apply,
          class: "w100"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"]),
        _createVNode(_component_SeButton, {
          ref: "logoutBtn",
          onPress: _ctx.state.logout,
          class: "w100"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("logout")), 1)
          ]),
          _: 1
        }, 8, ["onPress"])
      ])
    ])
  ]))
}